import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_lava-refresh/artifacts/cr75vzod_logo%20kilolava.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-text-primary text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL}
                alt="Kilolava Logo"
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-white/70 max-w-md mb-6 leading-relaxed">
              Servizi professionali di pulizie e lavanderia per case vacanza, hotel, uffici, condomini e ristoranti a Trieste.
            </p>
            <div className="flex flex-col gap-3">
              <a href="tel:+393513416151" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors">
                <Phone className="w-5 h-5" />
                <span>+39 351 341 6151</span>
              </a>
              <a href="mailto:info@kilolava.it" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors">
                <Mail className="w-5 h-5" />
                <span>info@kilolava.it</span>
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-5 h-5" />
                <span>Trieste, Italia</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-6">Servizi</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/pulizie" className="text-white/70 hover:text-primary transition-colors">
                  Pulizie Professionali
                </Link>
              </li>
              <li>
                <Link to="/biancheria" className="text-white/70 hover:text-primary transition-colors">
                  Lavanderia Biancheria
                </Link>
              </li>
              <li>
                <Link to="/tovagliato" className="text-white/70 hover:text-primary transition-colors">
                  Noleggio Tovagliato
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-6">Info</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://www.iubenda.com/privacy-policy/67491912" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-primary transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://www.iubenda.com/privacy-policy/67491912/cookie-policy" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-primary transition-colors">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="text-white/50 text-sm text-center">
            © Kilolava {currentYear} Tutti i diritti riservati. P.iva: 01275560322
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
